'use strict';

$(document).ready(function () {
    $.fn.init_minicart = function () {
        $(this).each(function () {
            var $fn = $(this);

            $('.minicart__overlay,.minicart__close', $fn).on('click', function () {
                $('body').removeClass('minicart-open');
            });
            $fn.on('click', '.minicart__close', function () {
                $('body').removeClass('minicart-open');
            });

            var update_cart = function update_cart($row) {

                var row_index = $('.minicart__item').index($row);
                //var line = $('.minicart__item').length - row_index;
                //var line = row_index;
                var id = $row.data('id');
                var quantity = $row.find('input').val();

                //                console.log($row);
                //console.log(row_index + " " + line + " " + quantity);
                //                
                //                return;

                $.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    dataType: 'json',
                    data: 'id=' + id + '&quantity=' + quantity,
                    success: function success() {
                        $.ajax({
                            type: 'GET',
                            url: '/cart/?view=minicart',
                            success: function success(result) {
                                $('.minicart__wrapper', $fn).html(result);
                            },
                            error: function error() {}
                        });
                    },
                    error: function error() {}
                });
            };

            $fn.on('click', '.minicart__item-quantity .minus', function () {
                var $obj = $(this);
                var $input = $obj.parent().find('input');
                var current_val = parseInt($input.val());
                if (current_val >= 1) {
                    $input.val(current_val - 1);
                }

                update_cart($obj.parents('.minicart__item'));
            });
            $fn.on('click', '.minicart__item-quantity .plus', function () {
                var $obj = $(this);
                var $input = $obj.parent().find('input');
                var current_val = parseInt($input.val());
                $input.val(current_val + 1);

                update_cart($obj.parents('.minicart__item'));
            });
        });
    };
    $('.minicart').init_minicart();
});